import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [-40.39, 100, 229.06],
  minDistance: 100,
  maxDistance: 500,
  minAzimuthAngle: -Math.PI / 18,
  maxAzimuthAngle: Math.PI / 5,
  minPolarAngle: Math.PI / 5,
  maxPolarAngle: Math.PI / 2,
  target: [0, 70, 0],
  getShadowManXPosition: (width: number) => -width / 2 - 50,
}
